import { EVENT_TYPE } from 'src/features/eventLog/types';
import { Translation, TranslationsWithId } from 'src/types';

export type StatisticEntry = {
    visitor: {
        id: string;
        main_identifier?: {
            value?: string;
        };
    };
    passed_on: string;
    entry_gateway: TranslationsWithId;
    active_stay?: {
        id: string;
    };
    past_stay?: {
        id: string;
    };
};

export type StatisticExit = {
    visitor: {
        id: string;
        main_identifier?: {
            value?: string;
        };
    };
    passed_on: string;
    exit_gateway: TranslationsWithId;
    active_stay?: {
        id: string;
    };
    past_stay?: {
        id: string;
    };
};

type EventDataVisitor = {
    id: string;
    main_identifier?: {
        value?: string;
    };
};

export type StatisticEvent = {
    timestamp: string;
    event_type: EVENT_TYPE;
    event_data: {
        identifiers?: {
            value: string;
        }[];
        // Depending on the event type the visitor is either a single object (e.g. active-stay-created)
        // or a list (e.g. gateway-pass).
        visitor?: EventDataVisitor | EventDataVisitor[];
    };
};

export type StatisticZone = {
    taken_spaces: number;
    total_spaces: number;
    free_spaces: number;
    zone: string;
    translations: Translation[];
    compared_to_last_day?: number;
};

export type HomeStatistics = {
    stats_by_zones: StatisticZone[];
    total_occupancy: {
        total_spaces: number;
        currently_occupied_spaces: number;
        total_membership_spaces: number;
        currently_occupied_membership_spaces: number;
        total_client_spaces: number;
        currently_occupied_client_spaces: number;
        compared_to_last_day?: number;
    };
    total_visits: {
        visits_count: number;
        visitors_count: number;
        compared_to_last_day?: number;
    };
    membership_visits: {
        visits_count: number;
        members_count: number;
        compared_to_last_day?: number;
    };
    total_spaces: number;
    taken_spaces: number;
    free_spaces: number;
    total_entries: number;
    total_exits: number;
    total_events: number;
    entries: {
        last_entries: StatisticEntry[];
        total_entries: number;
    };
    exits: {
        last_exits: StatisticExit[];
        total_exits: number;
    };
    total_stats_for_zones: {
        currently_free_spaces: number;
        total_spaces: number;
        compared_to_last_day?: number;
    };
};

export type EventHomeStatistics = {
    total_events: number;
    last_events: StatisticEvent[];
};

export const RADIAL_BAR_FILLS = ['#0BA5EC', '#0086C9', '#026AA2'];

export const BAR_FILLS = [
    'var(--color-primary-400)',
    'var(--color-primary-500)',
    'var(--color-primary-600)',
    'var(--color-primary-700)',
    'var(--color-primary-800)',
    'var(--color-primary-900)',
];

export const ACTIVE_STAYS_PANEL_NAME = 'active-stays-panel';

export const PAST_STAYS_PANEL_NAME = 'past-stays-panel';
